<div class="options">
  <app-select-market></app-select-market>
</div>

<div class="controls">
  <div>
    <input type="text" [(ngModel)]="textFilter" (keyup)="filterContainers()">
  </div>
  <div></div>
  <div>
    <button><img src="assets/images/add-button.svg" (click)="openContainerModal()"/></button>
  </div>
</div>

@if (selectedMarket) {
  <table>
    <tr class="header">
      <th>{{ 'CONTAINER.ACTIVATED' | translate }}</th>
      <th>{{ 'PRODUCT.CONTAINER' | translate }}</th>
      <th>{{ 'CONTAINER.CAPACITY' | translate }} ({{ selectedMarket.volumeUom }})</th>
      <th>{{ 'CONTAINER.PRESSURE' | translate }} ({{ selectedMarket.pressureUom }})</th>
      <th>{{ 'CONTAINER.EMPTY_TARE' | translate }} ({{ selectedMarket.weightUom }})</th>
      <th>{{ 'CONTAINER.TRANSPORT_COMPANY' | translate }}</th>
      <th>{{ 'CONTAINER.MODEL_NAME' | translate }}</th>
      <th></th>
    </tr>
    @for (container of displayedContainers; track container) {
      <tr>
        <td>
          <input type="checkbox"
            [checked]="container.isActivated"
            (change)="toggleContainerActivation(container)"/>
        </td>
        <td>{{ container.containerId }}</td>
        <td>{{ container.containerMaxCapacity | number : '1.0-0' }}</td>
        <td>{{ container.containerMAWP | number : '1.0-2' }}</td>
        <td>{{ container.containerTareWeight | number : '1.0-0' }}</td>
        <td>{{ container.transportcompanyName }}</td>
        <td>{{ container.containermodelName }}</td>
        <td>
          <img src="assets/images/trash-icon.svg"
            (click)="removeContainer(container)" class="delete"/>
        </td>
      </tr>
    }
  </table>
}

@if (addingContainer) {
  <app-create-container
    [market]="selectedMarket"
    (closeModal)="closeContainerModal($event)">
  </app-create-container>
}